/**
 * Layout definitions for OpenAI Files API data entry.
 * See: https://developers.openai.com/api/reference/resources/files
 */

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "FilenName",
                "tableName": "File",
                "label": "File Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "Purpose",
                "tableName": "File",
                "label": "Purpose",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
];

const PrimaryLayout = () => [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "Id",
                "tableName": "File",
                "label": "File ID",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "CreatedAt",
                "tableName": "File",
                "label": "Created At (Unix timestamp)",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "FileName",
                "tableName": "File",
                "label": "File Name",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "Bytes",
                "tableName": "File",
                "label": "Size (bytes)",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "Status",
                "tableName": "File",
                "label": "Status",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "ExpiresAt",
                "tableName": "File",
                "label": "Expires At (Unix timestamp)",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    }
    ,
    {
        "groupId": 4,
        "fields": [
            {
                "name": "Purpose",
                "tableName": "File",
                "label": "Purpose",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    }

];

export {
    SearchLayout,
    PrimaryLayout
};
